export default __webpack_public_path__ + "static/media/dozule2.2daa396b.jpg";